import * as constants from './constants';
import * as queries from './marketing-materials-graphql-query';
import debounce from 'lodash.debounce';
import checkStatus from '../../utils/checkStatus';
import { loadPartners } from '../actions';
import { merge } from 'ramda';

export const getPartnersForMM = () => loadPartners(constants.GETTING_PARTNERS, constants.GOT_PARTNERS);

export function updateMMProps(payload) {
  return { type: constants.UPDATE_MM_PROP, payload };
}

export function updateMMPartnerProps(payload) {
  return { type: constants.UPDATE_MM_PARTNER_PROP, payload };
}

export function checkConnection(payload) {
  return { type: constants.CHECK_CONNECTION, payload };
}

export function uncheckConnection(payload) {
  return { type: constants.UNCHECK_CONNECTION, payload };
}

export function clearStore() {
  return { type: constants.CLEAR_STORE };
}

export function getMarketingMaterials(companyId) {
  return dispatch => {
    dispatch({ type: constants.GETTING_MARKETING_MATERIALS });
    return fetch(`/proxy/company/${companyId}?query=${queries.MMQuery}`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(res => res.json())
    .then(response => dispatch({ type: constants.GOT_MARKETING_MATERIALS, payload: response }));
  };
}

export function editMMField({ updateField, updateBody }) {
  return dispatch => {
    dispatch({ type: constants.EDIT_MM_STARTING, payload: { updateField, updateBody } });
    return fetch(`/proxy/profile?mutation=${queries.editMMMutation}`, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        [updateField]: updateBody,
      }),
    })
    .then(res => res.json())
    .then(response => dispatch({ type: constants.EDIT_MM_FINISHED, payload: response }))
    .catch(err => console.log('err in saving mm', err));
  };
}

export function sendMM(payload) {
  return dispatch => {
    dispatch({ type: constants.SENDING_MARKETING_MATERIALS });
    return fetch('/proxy/profile/sendMarketingMaterials', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    .then(checkStatus)
    .then(() => dispatch({ type: constants.SENT_MARKETING_MATERIALS }))
    .catch(err => console.log('err in sending mm', err));
  };
}

const getCompanies = debounce((companyName, dispatch) => {
  return fetch(`/proxy/contractingSignUp/getCompanies/${companyName}`)
  .then(res => res.json())
  .then(res => {
    return dispatch({ type: constants.UPDATE_TYPE_AHEAD_COMPANIES_FOR_MM, payload: res });
  })
  .catch(res => {
    throw new Error(res.message);
  });
}, 400);

// SIGN UP ACTIONS

export function updateMMSignUpProps(payload) {
  return { type: constants.UPDATE_MM_SIGN_UP_PROP, payload };
}



// WEBPACK FOOTER //
// ./src/app/stores/marketing-materials/actions.js